"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _typography = require("@vds-core/typography");
var Feature = function Feature(props) {
  return /*#__PURE__*/_react["default"].createElement(_typography.Feature, (0, _extends2["default"])({}, props, {
    letterSpacing: "0px",
    bold: true
  }));
};
var _default = exports["default"] = Feature;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/typography/dist/cjs/components/Feature/Feature.js
// module id = 1623
// module chunks = 0